
<template>
    <div class="signUp">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <alert v-model="error.show" placement="top-right" duration="0" type="danger" width="400px" dismissable>
                        <span class="icon-info-circled alert-icon-float-left"></span>
                        <strong>Error:</strong>
                        <p id="signup_errormsg">{{error.message}}</p>
                    </alert>
                    <div class="row margin-top">
                        <div class="col-md-7">
                            <div class="main-content text-left left-content">
                                <hr>
                                <h2>Hello Team Novo Nordisk! We are glad you're here. You are just 1 step away from completing your TONE membership!
<!--                                    Welcome to TONE.-->
<!--                                    <br>-->
<!--                                    <span v-if="getTrialDays > 1">Your trial period will expire in {{getTrialDays}} days.</span>-->
<!--                                    <span v-if="getTrialDays === 0">Your trial is expiring today.</span>-->
<!--                                    <span v-if="getTrialDays === 1">Your trial is expiring tomorrow.</span>-->
<!--                                    <span v-if="getTrialDays < 0">Your trial period has expired.</span>-->
<!--                                    &nbsp;But don't worry - you can keep enjoying TONE by becoming a member!-->
                                </h2>
                            </div>
                            <div class="left-content">
                                <accordion :one-at-atime="true">
                                    <panel :is-open="true"  class="text-left">
                                        <div class="create-account">
                                            <div class="form">
                                                <form action="/charge" method="post" id="payment-form" v-on:submit.prevent="onPaymentSubmit">
                                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12  padding-minus">
                                                        <div class="clearfix"></div>

<!--                                                        <h3 style="text-align: center">Choose your membership plan:</h3>-->
                                                        <div class="clearfix"></div>

                                                        <div class="checkboxholder">
                                                            <div class="row">
<!--                                                                <div class="col-sm-4">-->
<!--                                                                    <div class="radio">-->
<!--                                                                        <label>-->
<!--                                                                            <span class="heading">Two Year Plan</span>-->
<!--                                                                            <span class="plan-price">${{twoYearPlan.description}} <span class="permonth">per month</span></span>-->
<!--                                                                            <input  v-if= "twoYearPlan" type="radio" id="2yearplan" :value="twoYearPlan.packageId" v-model="packageId" name="planselection" />-->
<!--                                                                            <span class="footertext">${{twoYearPlan.amount}} billed annually</span>-->
<!--                                                                        </label>-->
<!--                                                                    </div>-->
<!--                                                                </div>-->
                                                                <div class="col-sm-12">
                                                                    <div class="radio popular" style="text-align: center">
                                                                        <label>
                                                                            <span class="heading">One Year Plan</span>
                                                                            <span class="plan-price">$120
<!--                                                                                {{annualPlan.description}}-->
<!--                                                                                <span class="permonth">per month</span>-->
                                                                            </span>
                                                                            <input  v-if= "annualPlan" type="radio" id="annualplan" :value="annualPlan.packageId" v-model="packageId" name="planselection" />
<!--                                                                            <span class="footertext">${{annualPlan.amount}} billed annually</span>-->
                                                                        </label>
                                                                    </div>
                                                                </div><div class="col-sm-4">
<!--                                                                <div class="radio">-->
<!--                                                                    <label>-->
<!--                                                                        <span class="heading">Monthly Plan</span>-->
<!--                                                                        <span class="plan-price">${{defaultPlan.amount}} <span class="permonth">per month</span></span>-->
<!--                                                                        <input  v-if= "defaultPlan" type="radio" id="monthlyplan" :value="defaultPlan.packageId" v-model="packageId" name="planselection" />-->
<!--                                                                        <span class="footertext">billed monthly</span>-->
<!--                                                                    </label>-->
<!--                                                                </div>-->
                                                            </div>
                                                            </div>
                                                        <!--<div class="checkboxholder">-->
                                                            <!--<div class="radio">-->
                                                                <!--<label>-->
                                                                    <!--<input type="radio" id="regularplan" :value="defaultPlan.packageId" v-model="packageId" name="planselection" />&nbsp;Monthly membership&nbsp;({{ defaultPlan.type }}&nbsp;trial): ${{defaultPlan.amount}}-->
                                                                <!--</label>-->
                                                            <!--</div>-->
                                                            <!--<div class="radio">-->
                                                                <!--<label>-->
                                                                    <!--<input  v-if= "annualPlan" type="radio" id="annualplan" :value="annualPlan.packageId" v-model="packageId" name="planselection" />&nbsp;Annual membership&nbsp;({{ annualPlan.type }}&nbsp;trial): ${{annualPlan.amount}}-->
                                                                <!--</label>-->
                                                            <!--</div>-->


                                                        <!--<div class="checkbox">-->
                                                            <!--<label>-->
                                                                <!--<input v-if="defaultPlan" v-model="isMonthlySubscription" type="checkbox" disabled/> Monthly membership ${{defaultPlan.amount}}-->
                                                            <!--</label>-->
                                                        <!--</div>-->
                                                        <!--<div class="checkbox">-->
                                                            <!--<label>-->
                                                                <!--<input v-if="annualPlan" type="checkbox" v-model="isAnnualSubscription"/> Annual membership ${{annualPlan.amount}}-->
                                                            <!--</label>-->
                                                        <!--</div>-->
                                                        </div>
                                                        <div class="clearfix"></div>
                                                        <!--<div class="redoutlinebox">-->
                                                            <!--Special offer! For a limited time, receive a free copy of TONE Expert Debi Silber's latest book, <strong>The Unshakable Woman</strong>, with purchase of an annual membership.-->
                                                        <!--</div>-->
                                                        <div class="clearfix"></div>
                                                        <div class="codediv">
                                                            <div class="radiowrapper"><input type="radio" id="one" value="CC" v-model="gateway" name="paymentMethod">
                                                                <label for="one">Credit Card</label>

<!--                                                                <input type="radio" id="two" value="paypal" v-model="gateway" name="paymentMethod">-->
<!--                                                                <label for="two">Paypal</label>-->
                                                            </div>
                                                            <bs-input autocomplete="cc-name" label="Card Holder Name" id="paymentMethod_cardHolder"
                                                                      v-model = "userObject.cardHolderName"
                                                                      v-if="gateway === 'CC'"
                                                                      v-bind:pattern="/^[A-Za-z ]+$/"
                                                                      type="text"
                                                                      class="form-input"
                                                                      error="Card Holder Name (no digits allowed)"
                                                                      placeholder="Card Holder Name"
                                                                      required
                                                                      name="cardholdername"
                                                                      icon>
                                                            </bs-input>
                                                        <div class="stripeholder" v-if="gateway==='CC'">
                                                        <i aria-hidden="true" class="fa fa-lock overlapstripe" v-if="gateway==='CC'"></i>
                                                            <div id="card-element" class="field"></div>
                                                            <!-- Used to display form errors -->
                                                            <div v-if="stripeErrorMessage" role="alert" style="color:#a94442;margin:2px;">{{stripeErrorMessage}}</div>
                                                        </div>
                                                            <div class="row" v-if="gateway==='paypal'">
                                                                <div class="col-md-4">
                                                                    <div id="paypal-button" class="text-center margin-top-10 margin-bottom-10"></div>
                                                                    <!--<div id="dropin-container"></div>-->
                                                                    <!--<button id="submit-button">Request payment method</button>-->
                                                                </div>
                                                                <div style="margin-bottom: 10px" class="col-md-9" v-if="userPayments.paymentMethodNonce">
                                                                  <span  class="icon-info-circled alert-icon-float-left success">
                                                        <p class="alert alert-success alert-dismissable" ><i class="fa fa-check-square-o" aria-hidden="true"></i>Payment successfully authorized</p>
                                                        </span>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <checkbox class="terms-and-condition" v-model="isChecked" value="isChecked" type="primary">
                                                            &nbsp;I agree to <a href="/terms" target="_blank" rel="opener">terms and conditions</a>
                                                            <!--I agree to-->
                                                            <!--<router-link  :to="{ path: '/terms'}">-->
                                                                <!--terms and conditions-->
                                                            <!--</router-link>-->
                                                        </checkbox>
                                                    </div>
                                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right">
                                                        <!--<button class="btn formButton btn-block" type="submit" id="signup_button" :disabled="isUserLoggedIn">-->
                                                        <button class="btn formButton btn-block" type="submit" id="signup_button"  :disabled = "!isChecked || spinner" name="completesignupbutton">
                                                            Become a Member
                                                            <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </panel>
                                </accordion>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="right-content">
                                <div class="jumbotron">
                                    <div class="hidemobile"><h2>Your Plan</h2><p>What You Get</p></div>
                                    <div class="showmobile"><h2>What You Get</h2></div>
                                </div>
                            </div>
                            <div class="right-content">
                                <div class="card">
                                    <!--<div class="card-header text-center">-->
                                        <!--<h3>-->
                                            <!--YOUR PLAN-->
                                        <!--</h3>-->
                                    <!--</div>-->
                                    <div class="card-block">
                                        <div class="list-group">
                                            <li>Access to highly credentialed experts for on-demand guidance and coaching to help you grow personally and professionally</li>
                                            <li>Over 1000 bite-sized original videos designed for the working woman who is short on "free time"</li>
                                            <li>An open invitation to all live streaming events with our credentialed experts and career coaching sessions. Learn and ask questions with other Tone members</li>
                                            <li>A personalized experience. TONE is self-directed, so you go at your own pace and just watch what you want</li>
                                            <li>Custom communications:<br>
                                            <i>TONE Teasers</i>: customized emails serve up videos selected just for you<br>
                                            <i>TONE Takeaways</i>: reminder emails reinforce the skills you learn and help make it stick</li>
                                            <li>Membership to a vibrant community of like-minded professional women who share your passions, challenges and goals. Learn from each other in live-streaming and interactive coaching sessions</li>
                                            </div>
                                    </div>
                                    <!--<div class="card-footer hidemobile" >-->
                                        <!--<div class="list-group">-->
                                            <!--<li class="list-group-item">-->
                                                <!--<strong>{{defaultPlan.description}}</strong>-->
                                                <!--&lt;!&ndash;<input type="radio" name = "pkg" :value="defaultPlan.packageId" v-model="packageId" :checked="defaultPlan.packageId == packageId" />&nbsp;&nbsp;<strong>{{ defaultPlan.type }}</strong> (${{defaultPlan.amount}}) - {{defaultPlan.description}}&ndash;&gt;-->
                                            <!--</li>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { accordion, dropdown, radio, tab, buttonGroup } from 'vue-strap'
    import spinner from '@/accessibility/Spinner'
    import panel from '@/accessibility/Panel'
    import alert from '@/accessibility/Alert'
    import tabs from '@/accessibility/Tabs'
    import input from '@/accessibility/Input'
    import checkbox from '@/accessibility/Checkbox'
    import VuePassword from '@/accessibility/Password'
//    import store from '../store'
//    import $ from 'jquery'
    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'accordion': accordion,
            'panel': panel,
            alert,
            dropdown,
            radio,
            VuePassword,
            checkbox,
            tabs,
            tab,
            buttonGroup
        },
        name: 'signUp',
        metaInfo () {
            return {
                title: 'TONE | Your Trial has Expired',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {property: 'og:title', content: 'TONE | Your Trial has Expired'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'twitter:title', content: 'TONE | Your Trial has Expired'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                GifteeUser: {
                    userId: 0,
                    email: '',
                    password: '',
                    firstName: '',
                    lastName: '',
                    packageId: 0,
                    comments: '',
                    picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg'
                },
                userObject: {
                    userId: 0,
                    email: '',
                    password: '',
                    firstName: '',
                    lastName: '',
                    cardHolderName: '',
                    packageId: '',
                    userPayments: [],
                    isPaypalCustomer: '',
                    paypalSubscriptionId: '',
                    picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg'
                },
//            paymentInfo: {
//                email: '',
//                packageId: '',
//                userPayments: []
//            },
                userPayments: {
                    token: '',
                    stripeCardId: '',
                    paymentType: 'CC',
                    paymentDate: new Date(),
                    paypalPayerId: '',
                    paypalPaymentId: '',
                    paymentMethodNonce: ''
                },
                spinner: false,
                alert: false,
                passwordError: '',
                confirmPassword: '',
                stripe: '',
                card: '',
                panelStatus: false,
                createSection: true,
                paymentSection: false,
                isToggle: false,
                defaultPlan: '',
                isChecked: false,
                reqPlanCode: this.$route.params.planId ? this.$route.params.planId : '7DaysFree',
                daysToCancel: 0,
                isStripe: true,
                packageId: 0,
                // stripeKey: process.env.NODE_ENV !== 'development' ? 'sk_live_KO9T0KeJN7rWRXtYKSzju5KI' : 'sk_live_KO9T0KeJN7rWRXtYKSzju5KI',
//                stripeKey: 'pk_test_SLHUyTkZmNS1OnLNdclgNldo', // For local testing
                stripeKey: 'pk_test_SLHUyTkZmNS1OnLNdclgNldo',
                gateway: 'CC',
                paypalPayerID: '',
                paypalPaymentId: '',
                paypalToken: '',
               // paypalObject: window.paypal.Button,
                paypalResponse: '',
                giftCode: '',
                codeRedeemed: false,
                stripeErrorMessage: '',
                hidePasswordMeter: true,
                isMonthlySubscription: true,
                isAnnualSubscription: false,
                annualPlan: '',
                planAmount: 0,
                twoYearPlan: null
            }
        },
        mounted () {
            console.log('inside novo page')
            if (this.user && (this.user.trialEndDate && this.user.trialEndDate.length > 0)) {
                console.log('inside novo page 2')
                this.$store.dispatch('GETPLANS').then(() => {
                    let regularPlan = this.getAllPlans.filter(x => {
                        return x.packageId === 15
                    })
                    if (regularPlan && regularPlan.length > 0) {
                        let regPlan = regularPlan[0]
                        this.defaultPlan = regPlan
                        this.userObject.packageId = regPlan.packageId
                        this.packageId = regPlan.packageId
                    }
                    // Get annual Plan
                    let annualPlan = this.getAllPlans.filter(x => {
                        return x.packageId === 12
                    })
                    if (annualPlan && annualPlan.length > 0) {
                        this.annualPlan = annualPlan[0]
                        this.userObject.packageId = this.annualPlan.packageId
                        this.packageId = this.annualPlan.packageId
                        this.planAmount = this.annualPlan.amount
                    }
                    // Get two years plan
                    let twoYearPln = this.getAllPlans.filter(x => {
                        return x.packageId === 11
                    })
                    if (twoYearPln && twoYearPln.length > 0) {
                        this.twoYearPlan = twoYearPln[0]
                    }
                })
//                    // Get Regular Plan with Instant with instant payment
//                    let regularPlan = this.getAllPlans.filter(x => {
//                        return x.packageId === 20
//                    })
//                    if (regularPlan && regularPlan.length > 0) {
//                        let regPlan = regularPlan[0]
//                        this.defaultPlan = regPlan
//                        this.userObject.packageId = regPlan.packageId
//                        this.packageId = regPlan.packageId
//                    }
//                    // Get Annual Plan
//                    let annualPlan = this.getAllPlans.filter(x => {
//                        return x.packageId === 14
//                    })
//                    if (annualPlan && annualPlan.length > 0) {
//                        this.annualPlan = annualPlan[0]
//                    }
                this.$store.dispatch('GETPAYPALTOKEN')
                this.mountStripeElement()
            } else {
                this.$router.push('/')
            }
        },
        methods: {
            mountbraintree () {
                let self = this
                if (self.getPaypalToken) {
                    window.braintree.client.create({
                        authorization: 'production_6r7mxqgh_htw3nq9wp32w8h2x'
                    }, function (clientErr, clientInstance) {
                            // Stop if there was a problem creating the client.
                            // This could happen if there is a network error or if the authorization
                            // is invalid.
                        if (clientErr) {
                            console.error('Error creating client:', clientErr)
                            return
                        }
                            // Create a PayPal Checkout component.
                        window.braintree.paypalCheckout.create({
                            client: clientInstance
                        }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                            // Stop if there was a problem creating PayPal Checkout.
                            // This could happen if there was a network error or if it's incorrectly
                            // configured.
                            if (paypalCheckoutErr) {
                                console.error('Error creating PayPal Checkout:', paypalCheckoutErr)
                                return
                            }
                            // Set up PayPal with the checkout.js library
                            window.paypal.Button.render({
                                env: 'production', // or 'sandbox'
                                payment: function () {
                                    return paypalCheckoutInstance.createPayment({
                                        flow: 'vault',
                                        amount: self.planAmount,
                                        currency: 'USD',
                                        intent: 'sale'
                                        // Your PayPal options here. For available options, see
                                        // http://braintree.github.io/braintree-web/current/PayPalCheckout.html#createPayment
                                    })
                                },
                                onAuthorize: function (data, actions) {
                                    return paypalCheckoutInstance.tokenizePayment(data)
                                        .then(function (payload) {
                                            // console.log('nonce', payload.nonce)
                                                // Submit `payload.nonce` to your server.
                                            self.userPayments.paymentMethodNonce = payload.nonce
                                        })
                                },
                                onCancel: function (data) {
                                    // console.log('checkout.js payment cancelled', JSON.stringify(data, 0, 2))
                                },
                                onError: function (err) {
                                    console.error('checkout.js error', err)
                                }
                            }, '#paypal-button').then(function () {
                                    // The PayPal button will be rendered in an html element with the id
                                    // `paypal-button`. This function will be called when the PayPal button
                                    // is set up and ready to be used.
                            })
                        })
                    })
                }
            },
            redeemCode () {
                if (this.giftCode && this.giftCode.length > 0) {
                    this.spinnerToggle()
                    this.$store.dispatch('GETGIFTEE', this.giftCode).then(() => {
                        this.spinnerToggle()
                        if (this.getGiftee) {
                            this.user.firstName = this.getGiftee.gifteeFirstName
                            this.user.lastName = this.getGiftee.gifteeLastName
                            this.user.email = this.getGiftee.gifteeEmail
                            this.user.packageId = this.getGiftee.packageId
                            this.user.comments = this.getGiftee.gifteeUuid
                            this.codeRedeemed = true
                            this.$store.dispatch('GETPLANS').then(() => {
                                let plan = this.getAllPlans.filter(pln => {
                                    return pln.packageId === this.getGiftee.packageId
                                })
                                this.defaultPlan = plan[0]
                            })
                        }
                    })
                }
            },
            togglePaymentMethods () {
                if (this.gateway === 'paypal') {
                    this.isStripe = false
                    setTimeout(() => {
                        this.mountbraintree()
                    }, 1000)
                } else {
                    this.isStripe = true
                    this.mountStripeElement()
                }
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            onSubmit () {
                if (this.user && this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                    this.isToggle = false
                    this.spinnerToggle()
                    this.$store.dispatch('VERIFYUSEREXISTS', {email: this.user.email}).then(() => {
                        this.spinnerToggle()
                        if (!this.error.show) {
                            this.isToggle = true
                            this.createSection = false
                            this.paymentSection = true
                            this.user.cardHolderName = this.user.firstName + ' ' + this.user.lastName
                            // mount strip element
                            this.isStripe = true
                            this.gateway = 'CC'
                            this.mountStripeElement()
                        }
                    })
                }
                // this.$router.push('/interestlist')
            },
            mountStripeElement () {
                // let stripeKey = this.stripeKey
                setTimeout(() => {
                    this.stripe = window.Stripe(this.stripeKey)
                    const elements = this.stripe.elements()
                    this.card = elements.create('card')
                    this.card.mount('#card-element')
                }, 2000)
            },
//            mountPayPalElement () {
//                var amount = this.defaultPlan.amount
//                window.paypal.Button.render({
//                    env: 'sandbox', // sandbox | production
//
//                    // PayPal Client IDs - replace with your own
//                    // Create a PayPal app: https://developer.paypal.com/developer/applications/create
//                    client: {
//                        sandbox: 'AZDxjDScFpQtjWTOUtWKbyN_bDt4OgqaF4eYXlewfBP4-8aqX3PiV8e1GWU6liB2CUXlkA59kJXE7M6R',
//                        production: 'Abcr096coCh2Ll2yRPSHi9t2e0XFS4MUtZtnar6JbU5oi9JrqLDfl7pXsrizBwzV21R-nQhnZZCNPLZa'
//                    },
//
//                    // Show the buyer a 'Pay Now' button in the checkout flow
//                    commit: true,
//
//                    // payment() is called when the button is clicked
//                    payment: function (data, actions) {
//                        // Make a call to the REST api to create the payment
//                        return actions.payment.create({
//                            payment: {
//                                transactions: [
//                                    {
//                                        amount: { total: amount, currency: 'USD' }
//                                    }
//                                ]
//                            }
//                        })
//                    },
//                    // onAuthorize() is called when the buyer approves the payment
//                    onAuthorize: function (data, actions) {
//                        if (sessionStorage.getItem('paypalToken')) {
//                            sessionStorage.removeItem('paypalToken')
//                            sessionStorage.setItem('paypalToken', data.paymentToken)
//                        } else {
//                            sessionStorage.setItem('paypalToken', data.paymentToken)
//                        }
//                        if (sessionStorage.getItem('paypalPaymentID')) {
//                            sessionStorage.removeItem('paypalPaymentID')
//                            sessionStorage.setItem('paypalPaymentID', data.paymentID)
//                        } else {
//                            sessionStorage.setItem('paypalPaymentID', data.paymentID)
//                        }
//                        if (sessionStorage.getItem('paypalPayerID')) {
//                            sessionStorage.removeItem('paypalPayerID')
//                            sessionStorage.setItem('paypalPayerID', data.payerID)
//                        } else {
//                            sessionStorage.setItem('paypalPayerID', data.payerID)
//                        }
//                    }
//                }, '#paypal-button-container')
//            },
            disablePaymentPanel () {
                this.panelStatus = false
            },
            verifyPaymentSubmit () {
                if (this.user.packageId > 0) {
                    return false
                }
                return true
            },
            verifyPassword () {
                if (this.user.password.length >= 6) {
                    // [^ ]{8,16}
//                    let re = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,}).{8,}$/
                    let re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/
                    if (!re.test(this.user.password)) {
                        this.passwordError = 'Min 8 Chars, One Upper Case, One Lower Case, One Digit!'
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyEmail () {
                if (this.user.email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(this.user.email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyFirstName () {
                if (this.user.firstName.length > 0) {
                    let re = /^[A-Za-z ]+$/
                    if (!re.test(this.user.firstName)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyLastName () {
                if (this.user.lastName.length > 0) {
                    let re = /^[A-Za-z ]+$/
                    if (!re.test(this.user.lastName)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyCardHolderName () {
                if (this.userObject.cardHolderName.length > 0) {
                    let re = /^[A-Za-z ]+$/
                    if (!re.test(this.userObject.cardHolderName)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            onPaymentSubmit () {
                let self = this
                if (this.codeRedeemed) {
                    if (this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                        this.GifteeUser.firstName = this.user.firstName
                        this.GifteeUser.lastName = this.user.lastName
                        this.GifteeUser.email = this.user.email.toLowerCase()
                        this.GifteeUser.password = this.user.password
                        this.GifteeUser.packageId = this.getGiftee.packageId
                        this.GifteeUser.comments = this.getGiftee.gifteeUuid
                        this.spinnerToggle()
                        this.$store.dispatch('SAVEGIFTEE', {giftee: this.GifteeUser}).then(() => {
                            if (!this.error.show) {
                                this.spinnerToggle()
                                this.$swal({
                                    title: 'Registration Success!',
                                    text: 'Welcome To TONE! For your security, please check your inbox for a Validation Email - TONE Networks within the next 12 hours.  (Don’t see it…check your spam folder.)',
                                    type: 'success',
                                    timer: 4000,
                                    showCancelButton: false,
                                    showConfirmButton: false
                                }).then(
                                    function () {
                                    },
                                    // handling the promise rejection
                                    function (dismiss) {
                                        if (dismiss === 'timer') {
                                        }
                                    }
                                )
                            } else {
                                this.spinnerToggle()
                            }
                        })
                    }
                } else {
                    this.userObject.packageId = 25
                    this.planAmount = 120
                    if (this.gateway !== 'CC') {
                        this.userObject.cardHolderName = ' '
                    }
                    if (this.userObject && this.verifyCardHolderName()) {
                        this.spinnerToggle()
                        this.userObject.email = this.user.email.toLowerCase()
                        this.userObject.userId = this.user.userId
                        if (this.gateway === 'CC') {
                            this.userObject.isPaypalCustomer = '0'
                            this.stripe.createToken(this.card).then((result) => {
                                if (result.error) {
                                    this.spinnerToggle()
                                    // Inform the user if there was an error
                                    // $(this.$el).find('#card-errors')
                                    // var errorElement = document.getElementById('card-errors')
                                    self.stripeErrorMessage = result.error.message
                                } else {
                                    // Send the token to your server
                                    const stripeToken = result.token.id
                                    const cardId = result.token.card.id
                                    // console.log('token', stripeToken)
                                    this.userPayments.token = stripeToken
                                    this.userPayments.stripeCardId = cardId
                                    if (this.userObject.userPayments.length > 0) {
                                        this.userObject.userPayments.pop()
                                    }
                                    this.userObject.userPayments.push(this.userPayments)
                                    if (stripeToken) {
                                        this.$store.dispatch('CHANGE_FREEP_REVIEW_TO_REGULAR_NOVO', {user: this.userObject}).then(() => {
                                            if (!this.error.show) {
                                                this.spinnerToggle()
                                                this.$swal({
                                                    title: 'Registration Success!',
                                                    text: 'Welcome To TONE!',
                                                    type: 'success',
                                                    timer: 4000,
                                                    showCancelButton: false,
                                                    showConfirmButton: false
                                                }).then(
                                                    function () {
                                                    },
                                                    // handling the promise rejection
                                                    function (dismiss) {
                                                        if (dismiss === 'timer') {
                                                        }
                                                    }
                                                )
                                            } else {
                                                this.spinnerToggle()
                                            }
                                        })
                                    }
                                }
                            })
                        } else if (this.userPayments.paymentMethodNonce) {
                            if (this.userObject.userPayments.length > 0) {
                                this.userObject.userPayments.pop()
                            }
                            this.userObject.userPayments.push(this.userPayments)
                            if (this.userPayments.paymentMethodNonce) {
                                this.$store.dispatch('CHANGE_FREEP_REVIEW_TO_REGULAR_NOVO', {user: this.userObject}).then(() => {
                                    if (!this.error.show) {
                                        this.spinnerToggle()
                                        this.$swal({
                                            title: 'Registration Success!',
                                            text: 'Welcome To TONE!',
                                            type: 'success',
                                            timer: 4000,
                                            showCancelButton: false,
                                            showConfirmButton: false
                                        }).then(
                                            function () {},
                                            // handling the promise rejection
                                            function (dismiss) {
                                                if (dismiss === 'timer') {
                                                }
                                            }
                                        )
                                    } else {
                                        this.spinnerToggle()
                                    }
                                })
                            }
                        } else {
                            this.spinnerToggle()
                        }
                    }
                }
            }
        },
        computed: {...mapGetters([
            'error', 'isUserLoggedIn', 'getDefaultPlan', 'getGiftee', 'getAllPlans', 'getPaypalToken', 'getTrialDays', 'user'])
        },
        watch: {
            'user.firstName' (to, from) {
                this.user.cardHolderName = `${this.user.firstName} ${this.user.lastName}`
            },
            'user.lastName' (to, from) {
                this.user.cardHolderName = `${this.user.firstName} ${this.user.lastName}`
            },
            'packageId' (to, from) {
                // this.user.packageId = this.packageId
                // if (this.packageId === 12) {
                //     this.planAmount = this.annualPlan.amount
                // } else if (this.packageId === 11) {
                //     this.planAmount = this.twoYearPlan.amount
                // } else {
                //     this.planAmount = this.defaultPlan.amount
                // }
//                console.log('package', this.packageId)
//                console.log('user package', this.user.packageId)
//                console.log('Plan Amount', this.planAmount)
            },
//            'isAnnualSubscription' (to, from) {
//                this.isMonthlySubscription = !this.isAnnualSubscription
//                if (this.isAnnualSubscription) {
//                    this.user.packageId = this.annualPlan.packageId
//                } else {
//                    this.user.packageId = this.defaultPlan.packageId
//                }
//            },
            'gateway' (to, from) {
                if (this.gateway === 'paypal') {
                    this.card.unmount('#card-element')
                    this.stripeErrorMessage = ''
                    this.isStripe = false
                    this.userPayments.token = ''
                    this.userPayments.paypalPayerId = ''
                    this.userPayments.paypalPaymentId = ''
                    this.userPayments.stripeCardId = ''
                    this.userPayments.paymentType = 'PayPal'
                    this.userObject.isPaypalCustomer = '1'
                    this.userPayments.paymentMethodNonce = ''
                    setTimeout(() => {
                        this.mountbraintree()
                    }, 1000)
                } else {
                    this.stripeErrorMessage = ''
                    this.userPayments.token = ''
                    this.userPayments.paypalPayerId = ''
                    this.userPayments.paypalPaymentId = ''
                    this.userPayments.stripeCardId = ''
                    this.userObject.isPaypalCustomer = '0'
                    this.userPayments.paymentType = 'CC'
                    this.userPayments.paymentMethodNonce = ''
                    this.isStripe = true
                    setTimeout(() => {
                        this.mountStripeElement()
                    }, 1000)
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    span.heading {
        position: relative;
        width: 100%;
        display: block;
        font-size: 19px;
        font-weight: 500;
        color: #a9a9a9;
    }

    .checkboxholder .radio {
        text-align: center;
        border: 1px solid #ddd;
        padding: 10px;
    }

    .checkboxholder {}

    .checkboxholder .radio label {
        padding: 0;
        letter-spacing: 0;
    }

    .checkboxholder .radio label span {
        display: block;
    }

    .checkboxholder .radio label input {
        position: relative;
        margin: 20px 0;
    }
    span.footertext {
        font-weight: 500;
        color: #a9a9a9;
    }

    span.plan-price {
        font-size: 34px;
        font-weight: 900;
        color: #a9a9a9;
    }
    .radio.popular:before {
        /*content: "Your special 12 Month Plan will be reimbursed by NNI";*/
        position: absolute;
        left: 0;
        right: 0;
        line-height: 1.3;
        /*background: #f0617d;*/
        color: black;
        transform: translatey(-100%);
        margin-top: -10px;
        padding: 5px 0;
    }

    .checkboxholder {
        /*padding-top: 30px;*/
    }
    span.permonth {
        display: block;
        font-size: 14px;
    }

    span.plan-price {
        line-height: 1.2;
        padding-top: 20px;
    }
    @media(min-width:768px){

        .radio.popular {
            margin-top: 30px;
        }
    }
    @media(max-width:767px){
        .radio.popular[data-v-3a43d266]:before {
            position: absolute;
            transform: translateY(-20px);
        }

        .radio.popular {
            padding-top: 30px !important;
        }
    }
    .StripeElement {
        background-color: white;
        padding: 2em 1em;
        border: 1px solid #ccc;
        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
        height: 34px;
    }
    .float-right.paymentswitch.btn-group {
        margin: 0 0 30px;
    }
    .StripeElement--focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }
    .radiowrapper {
        padding: 0 0px 10px;
        color: #f0617d;
    }
	div#paypal-button {
    text-align: center;
}
.codediv {
    padding: 10px 0 0;
}
.codediv + .row.code {
    padding-top: 0;
}
@media(min-width:768px) {
    .row.code + label.terms-and-condition {
        margin: 0;
    }
}
.stripeholder {}

.codediv .stripeholder {
    margin-bottom: 20px;
}

.codediv .col-md-12 {
    min-height: 0;
}
    .showmobile{
        display:none;
    }
    .stripeholder {
        position: relative;
    }

    i.fa.fa-lock.overlapstripe {
        position: absolute;
        left: 18px;
        top: 10px;
        font-size: 18px;
        color: #b2b8c7;
    }
    button.redeem.btn.formButton.btn-block {
        margin: 0;
    }

    .row.code {
        padding-top: 20px;
    }
    @media (max-width:767px){
        .hidemobile{
            display:none;
        }
        .showmobile{
            display:inherit;
        }
        .signUp .left-content h4 {
            font-size: 14px;
            letter-spacing: 0px;
        }

        .signUp .main-content h2 {
            margin: 15px 0;
            line-height: 20px;
            font-size: 18px;
        }

        .signUp #signup_pwderrormsg {
            margin-bottom: 8px;
            line-height: 1.3;
            letter-spacing: 1px;
        }

        .signUp .left-content .create-account #signup_button {
            margin: 0;
        }

        .signUp .right-content .jumbotron {
            padding: 6px;
            margin-top: 7px;
        }

        .signUp .right-content .jumbotron h2 {
            margin: 0;
            font-size: 21px;
        }

        .signUp .right-content .jumbotron p {
            display: none;
        }

        .signUp .right-content .card {
            padding: 10px 10px;
        }

        .signUp .right-content .card .card-block .list-group li {
            font-size: 16px;
            margin: 0 0 10px;
        }

        .signUp .left-content hr {
            display: none;
        }

        .row.margin-top {
            margin-top: 0px;
        }
		div#paypal-button {
			text-align: center!important;
			top: -3px;
		}
        .codediv .stripeholder {
            margin-bottom: 10px;
        }

    }

    /* Media query for mobile viewport */
    @media screen and (max-width: 400px) {
        #paypal-button-container {
            width: 100%;
        }
    }

    /* Media query for desktop viewport */
    @media screen and (min-width: 400px) {
        #paypal-button-container {
            width: 250px;
            display: inline-block;
        }
    }
    button.redeem.btn.formButton.btn-block {
        letter-spacing: 0;
    }
    .checkboxholder {
        /*padding-left: 30px;*/
        padding-bottom: 10px;
    }
    .checkboxholder .checkbox {
        font-size: 16px;
        letter-spacing: 3px;
        margin: 15px 0;
    }
    .redoutlinebox {
        border: 2px solid #f0617d;
        padding: 10px;
        margin: 0px 0px 20px;
        text-align: justify;
    }
    .checkboxholder .radio input[type="radio"] {
        opacity:1;
        z-index:20;
        top: 2px;
    }
    body .margin-top {
        margin-top: 89px;
        margin-bottom: 70px;
    }
    body .signUp .right-content .card .card-block .list-group{
        margin-bottom:0px;
    }
</style>



// WEBPACK FOOTER //
// TrialExpiry_Novo.vue?f565426a